import { gql } from '@apollo/client';

export const ALL_EMAIL_LOGS_QUERY_NAME = 'AllEmailLogs';
export const ALL_EMAIL_LOGS = gql`
    query ${ALL_EMAIL_LOGS_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allEmailLogs(
            page: $page,
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            emailLogList {
                totalCount
                models {
                    id
                    dateTime
                    subject
                    recipients
                    status
                    userId
                }
            }
        }
    }
`;
